import Card from "@mui/material/Card";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import CoverLayout from "layouts/authentication/components/CoverLayout";
import bgImage from "assets/images/bg-reset-cover.jpeg";
import UserService from "services/UserService";
import AuthService from "services/AuthService";

function Cover() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    const currentUser = AuthService.getCurrentUser();
    if (currentUser) {
      navigate('/ofertas');
    }
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    
    try {
      const params = { userEmail: email }
      setDisabled(true);
      await UserService
        .resetPassword(params)
        .catch((e) => {
          setDisabled(false); 
          throw e
        });
      setError({ type: "success", value: "Você receberá um e-mail nos próximos segundos. Siga os passos para redefinir sua senha." });
    }
    catch(e) {
      setDisabled(false);
      setError({ type: "error", value: "E-mail inválido!" });
      console.error(e)
    }
  };

  return (
    <CoverLayout coverHeight="50vh" image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          py={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h3" fontWeight="medium" color="white" mt={1}>
            Redefinir senha
          </MDTypography>
          <MDTypography display="block" variant="button" color="white" my={1}>
            Informe seu e-mail
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={handleSubmit} >
            <MDBox mb={4}>
              <MDInput type="email" label="Email" variant="standard" value={email} onChange={(e) => setEmail(e.target.value)} fullWidth  required />
            </MDBox>
            {error && (
              <MDBox mt={2}>
                <MDTypography variant="caption" color={error.type} fontWeight="light">
                  {error.value}
                </MDTypography>
              </MDBox>
            )}
            <MDBox mt={6} mb={1}>
              <MDButton variant="gradient" color="info" type="submit" fullWidth disabled={disabled}>
                redefinir
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </CoverLayout>
  );
}

export default Cover;
